module.exports = __webpack_public_path__ + "static/media/0xbtc.ca90430d.svg";